import { useEffect, useState } from "react";

import { Button, InfoModal, Checkbox } from "@newsela/angelou";
import { actionNames, withTrackEvent } from "@newsela/snitch";
import PropTypes from "prop-types";

import { getConSetVisibilityMarkers } from "@/assignments/utils/assignmentUtils";
import { ContentAdvisoryConsentMessage } from "@/components/ContentAdvisoryConsentMessage/ContentAdvisoryConsentMessage";
import useAdvisoryMessageGet from "@/district/hooks/useAdvisoryMessageGet";

import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";
import {
  advisoryModalCss,
  advisoryModalFooterCss,
  catCheckboxCss,
  catCheckboxLabelTextCss,
  advisoryModalRootCss,
  advisoryModalBodyCss,
} from "./AdvisoryModal.style";

const propTypes = {
  assignmentMembers: PropTypes.array,
  handleAdvisoryConfirmation: PropTypes.func,
  postCatAssignment: PropTypes.func,
  setCatModalActive: PropTypes.func,
  advisoryModalProps: PropTypes.object,
  setAdvisoryModalActive: PropTypes.func,
  contentMemberIds: PropTypes.arrayOf(PropTypes.string),
  updateContentSettingsOverride: PropTypes.func,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const AdvisoryModal = ({
  advisoryModalProps,
  assignmentMembers,
  handleAdvisoryConfirmation,
  setAdvisoryModalActive,
  contentMemberIds,
  updateContentSettingsOverride,
}) => {
  const { updatedAssignment } = useAssignmentReducerContext();

  const [acceptedContentAdvisory, setAcceptedContentAdvisory] = useState(false);
  const {
    data: { title, ...catProps },
  } = useAdvisoryMessageGet();

  const conSetVisibilityMarkers = getConSetVisibilityMarkers(
    assignmentMembers || [],
  );

  const onAdvisoryClose = () => {
    setAdvisoryModalActive(false);
    setAcceptedContentAdvisory(false);
  };

  useEffect(() => {
    if (updateContentSettingsOverride) {
      updateContentSettingsOverride(acceptedContentAdvisory);
    }
  }, [acceptedContentAdvisory]);

  return (
    <InfoModal
      __cssFor={{
        root: advisoryModalRootCss,
        modalContentWrapper: advisoryModalCss,
        footer: advisoryModalFooterCss,
        scrollableBody: advisoryModalBodyCss,
      }}
      labelId={title}
      onBackgroundClick={() => onAdvisoryClose()}
      title={title}
      closeButtonProps={{ onClick: () => onAdvisoryClose() }}
      {...advisoryModalProps}
      footer={
        <>
          <ButtonWithTrackEvent
            flavor={Button.flavors.secondary}
            _cssFor={{ root: { width: "166px !important!" } }}
            onClick={() => onAdvisoryClose()}
            actionName={actionNames.cancel}
            streamProperties={{
              description:
                "Close Student Restricted Content Modal In Assignment Editor.",
              component_type: "student-restricted-content-assignment",
              content_id: contentMemberIds,
              content_settings_override: false,
              event_name: "Cancel",
            }}
          >
            Cancel
          </ButtonWithTrackEvent>
          <ButtonWithTrackEvent
            disabled={
              !acceptedContentAdvisory &&
              !updatedAssignment?.content_settings_override
            }
            streamProperties={{
              description: "Choose To Assign In SRC Modal in Assignment Editor",
              component_type: "student-restricted-content-assignment",
              event_name: "Consent Event",
              actionName: actionNames.chooseToAssign,
              content_settings_override: true,
              content_id: contentMemberIds,
            }}
            onClick={handleAdvisoryConfirmation}
          >
            Continue
          </ButtonWithTrackEvent>
        </>
      }
    >
      <ContentAdvisoryConsentMessage
        {...catProps}
        conSetVisibilityMarkers={conSetVisibilityMarkers}
      />
      <Checkbox
        checked={acceptedContentAdvisory}
        __cssFor={{
          root: catCheckboxCss,
          emptyCheckbox: { paddingRight: "0px" },
          checkedBox: { paddingRight: "0px" },
          labelText: catCheckboxLabelTextCss,
        }}
        label="I’ve read this message and choose to assign the content."
        value="I’ve read this message and choose to assign the content."
        onClick={() => {
          setAcceptedContentAdvisory(!acceptedContentAdvisory);
        }}
      />
    </InfoModal>
  );
};
AdvisoryModal.propTypes = propTypes;
export default withTrackEvent(AdvisoryModal);
